import { useEffect } from "react";
import TagManager from "react-gtm-module";

interface GoogleTagManagerProps {
  gtmId: string;
}

const GoogleTagManagerComponent = ({ gtmId }: GoogleTagManagerProps) => {
  useEffect(() => {
    TagManager.initialize({ gtmId });
  }, [gtmId]);

  return null;
};

export default GoogleTagManagerComponent;
